<template>
  <div>
    <b-container style="margin: 2em auto;">
      <b-modal hide-footer title="Ödeme Makbuzu" v-model="receipt_modal" v-if="!_.isEmpty(receipt)">
          <div id="section-to-print">
            <b-container fluid>
              <b-row>
                <b-col cols="2">
                  <img :src="init.logo_src" style="width:200px;margin-bottom:20px;text-align:left;filter: brightness(0);">
                </b-col>
                <b-col cols="6"></b-col>
                <b-col cols="4">
                  <h3 style="padding: 20 0 20 20px;text-align:right;">Ödeme Makbuzu</h3>
                </b-col>
              </b-row>
              <b-row style="background-color:#ededed;border-top:1px solid #ddd;border-bottom:1px solid #ddd;padding:15px 15px 7px 15px">
                <b-col cols="4">
                  <h5 style="text-align:left;padding: 20 20 20 0px;">
                    <strong>Makbuz No: </strong> {{ receipt.id }}
                  </h5>
                </b-col>
                <b-col cols="4"></b-col>
                <b-col cols="4">
                  <h5 style="text-align:right;padding: 20 0 20 20px;">
                    <strong>Tarih: </strong> {{ $moment(receipt.created_at).format('MM.DD.YYYY h:mm:ss') }}
                  </h5>
                </b-col>
              </b-row>
            </b-container>
            <b-container fluid>
              <div class="row">
                <div class="col-xl-12">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Firma Ünvanı</td>
                          <td> {{ _.find(receipt.fields, [ 'name', 'company_name']).value }} </td>
                        </tr>
                        <tr>
                          <td>Firma Adresi</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'address']).value }}</td>
                        </tr>
                        <tr v-if="user.type == 2">
                          <td>Vergi Dairesi</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'tax_place']).value }}</td>
                        </tr>
                        <tr v-if="user.type == 2">
                          <td>Vergi Kimlik No</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'tax_number']).value }}</td>
                        </tr>
                        <tr v-if="user.type == 1">
                          <td>TC Kimlik No</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'identity_id']).value }}</td>
                        </tr>
                        <tr>
                          <td>Telefon Numarası</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'phone']).value }}</td>
                        </tr>
                        <tr>
                          <td>Yetkili Ad / Soyad</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'name']).value }} {{ _.find(receipt.fields, [ 'name', 'surname']).value }}</td>
                        </tr>
                        <tr>
                          <td>Yetkili e-Mail Adresi</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'email']).value }}</td>
                        </tr>
                        <tr>
                          <td>Ödeme Notu</td>
                          <td>{{ _.find(receipt.fields, [ 'name', 'note']).value }}</td>
                        </tr>
                        <tr>
                          <td>Ödeme Tutarı</td>
                          <td>{{ receipt.amount }}</td>
                        </tr>
                        <tr>
                          <td>Taksit Sayısı</td>
                          <td>{{ receipt.installment }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-container>
          </div>
          <b-button variant="secondary" onclick="window.print();" style="font-size:12px;">Yazdır</b-button>
      </b-modal>
      <b-row v-loading="loading">
        <div style="padding:5px 0px 5px 0px;margin:5px 0px 5px 0px;">
          <router-link to="/" style="margin-right:10px">
            <button type="button" class="btn btn-success">+ Yeni Ödeme</button>
          </router-link>
          <router-link :to="{ name: 'UpdateAccount' }">
            <button type="button" class="btn btn-secondary">Bilgilerimi Güncelle</button>
          </router-link>
        </div>
        <b-col cols="12" style="margin:15px 0; padding:0px">
          <b-card header="Filtreleme" header-tag="header" class="filter-panel">
            <b-row>
                <b-col cols="2">
                    <b-form-group label="Makbuz no">
                      <b-form-input type="number" size="sm" v-model="filter.id" placeholder="ID"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="Tutar">
                      <b-form-input type="number" size="sm" v-model="filter.amount" placeholder="Tutar"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Durum">
                    <b-form-select size="sm" v-model="filter.status" class="form-control mb-3 form-control-sm">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="0">Bekliyor</b-form-select-option>
                      <b-form-select-option :value="1">Onaylandı</b-form-select-option>
                      <b-form-select-option :value="2">Reddedildi</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group style="margin-top:30px">
                    <b-button variant="primary" @click="filterBtn()" style="font-size:12px; margin-right:10px" size="sm">Filtrele</b-button>
                    <b-button variant="danger" @click="clearBtn()" style="font-size:12px" size="sm">Temizle</b-button>
                  </b-form-group>
                </b-col>
            </b-row>
          </b-card>
        </b-col>
        <div class="table-responsive">
          <table style="table-layout:fixed; font-size:14px;vertical-align: middle;" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Makbuz No</th>
                <th scope="col">Tarih/Saat</th>
                <th scope="col">Durum</th>
                <th scope="col">Ad Soyad</th>
                <th scope="col">Firma Adı</th>
                <th scope="col">Açıklama</th>
                <th scope="col">Tutar</th>
                <th scope="col">Eylemler</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data" :key="key">
                  <td>{{ item.id }}</td>
                  <td>{{ $moment(item.created_at).format('MM.DD.YYYY h:mm:ss') }}</td>
                  <td><span :class="'text text-' + (item.status == 1 ? 'success' : (item.status == 2 ? 'danger' : 'warning'))">{{ item.status_name }}</span></td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.company_name }}</td>
                  <td>{{ _.first(_.filter(item.fields, { 'name': 'note'})).value }}</td>
                  <td>{{ item.amount }}</td>
                  <td>
                    <b-button variant="primary" @click="receipt_modal = true; setReceipt(item, false)" style="font-size:12px; margin-right:10px" size="sm">Göster</b-button>
                    <b-button variant="secondary" @click="receipt_modal = true;setReceipt(item, true);" style="font-size:12px;" size="sm">Yazdır</b-button>
                  </td>
                </tr>
            </tbody>
            <tfoot>
              <tr style="background-color:#f0f7ff;">
                <th colspan="6">Toplamlar</th>
                <th style="text-align:right;">0 TL</th>
                <th></th>
              </tr>
            </tfoot>
            <div class="block pagination">
              <el-pagination
                  v-if="filter.pageTotal > 0"
                  @size-change="handleSizeChange"
                  @current-change="fetch"
                  :current-page.sync="filter.page"
                  :page-sizes="sizes"
                  :page-size="filter.size"
                  layout="sizes, prev, pager, next"
                  :total="filter.pageTotal"
              ></el-pagination>
            </div> 
          </table>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default{
    name: 'MyAccount',
    data(){
      return{
        sizes: [10, 20, 50, 100],
        loading:false,
        receipt_modal: false,
        receipt:{},
        filter:{
          id: null,
          status:null,
          amount:null,
          pageTotal: 0,
          size: 10,
          page: 1,
          types: []
        },
        data:[]
      }
    },
    watch:{
        "filter.types": function(val) {
          this.fetch(1, this.filter.size);
        },
    },
    computed:{
      user(){
        return this.$user();
      },
      init(){
        return this.$store.getters['getInit'];
      },
    },
    created(){
      this.fetch();
    },
    methods:{
      setReceipt(val, print){
        this.receipt = val;
        setTimeout( ()=> {
          if(print){
            window.print();
          }
        }, 500)
      },
      filterBtn(){
        this.fetch(1, this.filter.size);
      },
      clearBtn(){
        this.filter.id = null;
        this.filter.status = null;
        this.filter.amount = null;
        this.fetch(1, this.filter.size);
      },
      handleSizeChange(value){
        this.filter.size = value;
        this.fetch();
      },
      fetch(page = 1, size = null, silent = false){
        this.filter.page = page;

        if (!_.isNull(size)) 
        {
            this.filter.size = size;
        }
        if(!silent) this.loading = true;
        axios.get('/account/transactions',{params: this.filter })
        .then((response) => {
          this.data = response.data.transactions.data;
          this.filter.pageTotal  	= response.data.transactions.total;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>
